import { join } from 'rambda'

const markdownLinkPattern = /\[([^[]+)\]\(([^(]+)\)/g

const replaceNthLink = (() => {
  return (text, n, replaceWith) => {
    const match = [...text.matchAll(markdownLinkPattern)][n]
    return join('', [
      text
        .slice(0, match.index),
      text
        .slice(match.index, text.length)
        .replace(match[0], replaceWith),
    ])
  }
})()

export const replaceMarkdownLink = (text, linkNo, label, url) => {
  return replaceNthLink(text, linkNo, toMarkdownLink(label, url))
}

export const removeMarkdownLink = replaceNthLink

export const parseLinks = (text) => [...text.matchAll(markdownLinkPattern)]
  .map(([_, label, url]) => ({
    label,
    url,
  }))

const toMarkdownLink = (label, url) => `[${label}](${url})`
